import { ORGANIZATIONS_ENDPOINT } from "Constants";
import { GetGroupListRequest, GetGroupListResponse } from "Types";
import { baseApi as api } from "./base.api";

export const organizationsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getGroupList: build.query<GetGroupListResponse, GetGroupListRequest>({
      query: (queryArg) => ({
        url: `${ORGANIZATIONS_ENDPOINT}/group/list`,
        params: {
          organization_id: queryArg.organizationId,
          group_name: queryArg.groupName,
          sort_by: queryArg.sortBy,
          limit: queryArg.limit,
          offset: queryArg.offset,
        },
      }),
      providesTags: ["Groups"],
    }),
  }),
  overrideExisting: false,
});

export const { useGetGroupListQuery } = organizationsApi;
